import * as yup from 'yup';

export const birthSchemaObject = {
  // matricola: yup.string().required('Campo obbligatorio'),
  surname: yup.string().required('Campo obbligatorio'),
  name: yup.string().required('Campo obbligatorio'),
  gender: yup.string().required('Campo obbligatorio'),
  birthday: yup.date().typeError('Data non valida').nullable(),
};

const birthSchema = yup.object().shape(birthSchemaObject);

export default birthSchema;
